import { useMemo, useState } from 'react'
import {
  saveVehicleTransfer,
  updateVehicleTransfer,
} from '../../../../../services/api/https/registration/veiculos-transferencia.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  NEW_VEICULO_TRANSFERENCIA: 'Salvando veiculo de transferência',
  UPDATE_VEICULO_TRANSFERENCIA: 'Atualizando veiculo de transferência',
  SUCCESS: 'Operação realizada com sucesso',
}

const INITIAL_VEHICLE_TRANSFER = {
  id: null,
  vehicle_badge: '___-____',
  category: 'Proprio',
  actived: true,
}

const INITIAL_STATE = {
  vehicleTransfer: { ...INITIAL_VEHICLE_TRANSFER },
  updatedVehicleTransfer: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export const CATEGORIES = [
  { label: 'Próprio', value: 'Proprio' },
  { label: 'Terceiro', value: 'Terceiro' },
]

export default function useVeiculoTransferenciaModal() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const validateFieldsWithMask = vehicleTransfer => {
      if (vehicleTransfer.vehicle_badge === '___-____') vehicleTransfer.vehicle_badge = null
      return vehicleTransfer
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      saveVehicleTransfer({ id, ...vehicleTransfer }, tpId) {
        saveVehicleTransfer(validateFieldsWithMask(vehicleTransfer), tpId)
          .then(updatedVehicleTransfer => {
            setState(prevState => ({
              ...prevState,
              updatedVehicleTransfer: updatedVehicleTransfer,
              vehicleTransfer: { ...INITIAL_VEHICLE_TRANSFER },
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      updateVehicleTransfer({ created_at, updated_at, ...vehicleTransfer }) {
        updateVehicleTransfer(vehicleTransfer)
          .then(updatedVehicleTransfer => {
            setState(prevState => ({
              ...prevState,
              updatedVehicleTransfer: updatedVehicleTransfer,
              vehicleTransfer: { ...INITIAL_VEHICLE_TRANSFER },
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInputChange(name, value) {
        setState(prevState => {
          prevState.vehicleTransfer[name] = value
          return { ...prevState }
        })
      },

      onBtnSalvarClick(vehicleTransfer) {
        if (vehicleTransfer.id)
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.UPDATE_VEICULO_TRANSFERENCIA,
          }))
        else
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NEW_VEICULO_TRANSFERENCIA,
          }))
      },

      onInit(vehicleTransfer) {
        setState(prevState => ({
          ...prevState,
          vehicleTransfer: vehicleTransfer ? vehicleTransfer : { ...INITIAL_VEHICLE_TRANSFER },
          vehicle_badge: '___-____',
        }))
      },

      onClose() {
        setState(prevState => ({ ...prevState, vehicleTransfer: { ...INITIAL_VEHICLE_TRANSFER } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
